<div *ngIf="isLoggedInUserAdmin && !hideToggleSwitch" ngClass="m-b-m">
	<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5%">
		<mat-slide-toggle
			[(ngModel)]="allowConnectedFundraiser"
			(change)="onToggleChange($event)"
			id="allow-connected-toggle"
			color="primary"
		>
			<span i18n="@@connect_fund_allow_connected_fundraisers"
				>Allow Connected Fundraisers</span
			>
		</mat-slide-toggle>
		<img
			matTooltip="{{ this.allowTooltip }}"
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
		/>
	</div>
</div>

<div fxLayout="column" fxLayoutAlign="center flex-start">
	<div fxLayout="row">
		<div fxLayout="column" ngClass="p-r-l">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/create/public"
			/>
		</div>
		<div fxLayout="column">
			<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2%">
				<span class="mat-headline-6" i18n="@@connectFund_supportACause_label">
					Connect with this fundraiser
				</span>
				<div ngClass="p-b-xs">
					<span>
						<img
							src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
							matTooltip="{{ titleDescriptionTooltip }}"
						/>
					</span>
				</div>
			</div>
			<div fxLayout="row" ngClass="p-b-m">
				<span i18n="@@connectFund_teamUpwithThisExistingFundraisers_label">
					Team up /connect with this existing fundraisers.
				</span>
			</div>
		</div>
	</div>

	<button
		id="connectFundraiserButton"
		mat-stroked-button
		color="accent"
		(click)="routeToConnectFundraiser()"
		class="w-100"
		i18n="@@button_connectFundraiser"
		[disabled]="!isAllowChild"
		matTooltip="{{ this.disableTooltip }}"
		[matTooltipDisabled]="isAllowChild"
	>
		Connect Fundraiser
	</button>
</div>
